export const {
  REGISTRATION_MAINTENANCE
} = window.__env__